import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import * as S from "./LineSectionChart.style";
import { useMemo } from "react";
import dayjs from "dayjs";

interface LineSectionChartProps {
  chartData?: any;
}

export const LineSectionChart = ({ chartData }: LineSectionChartProps) => {
  const options = useMemo(
    () => ({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      grid: {
        containLabel: true,
        left: 10,
        top: 20,
        right: 10,
        bottom: 0,
      },
      xAxis: {
        type: "category",
        data: (chartData && chartData[0]?.timeSlots) || [],
        axisLabel: {
          formatter: (value: any) => dayjs(value).format("YYYY.MM.DD HH:mm:ss"),
        },
      },
      yAxis: {
        type: "value",
        axisPointer: {
          snap: true,
        },
        min: 1, // y축 최소값을 1로 설정
        max: 5.4, // y축 최대값을 5로 설정
        interval: 1, // y축 간격을 1로 설정
        axisLabel: {
          formatter: (value: number) => (value === 5.4 ? "" : value), // 최대값 라벨만 숨기기
        },
      },
      series: [
        {
          name: "알람값",
          type: "line", // line chart
          lineStyle: {
            width: 0.8,
          },

          data: (chartData && chartData[0]?.counts) || [],
          markArea: {
            data: [
              // 기존의 3 ~ 5 사이 영역 배경색
              [
                {
                  itemStyle: {
                    color: "rgba(255, 200, 0, 0.2)", // 기존 배경색 설정
                  },
                  yAxis: 3, // 시작 y값
                },
                {
                  yAxis: 5, // 끝 y값
                },
              ],
              // 5에서 약간 위로 설정한 영역의 빨간색 배경
              [
                {
                  itemStyle: {
                    color: "rgba(255, 0, 0, 0.2)", // 빨간색 배경 설정
                  },
                  yAxis: 5, // 시작 y값
                },
                {
                  yAxis: 5.5, // 약간 위로 설정한 끝 y값
                },
              ],
            ],
          },
          markLine: {
            data: [
              {
                yAxis: 3, // 표시하고 싶은 y값
                label: {
                  formatter: "", // 원하는 라벨 텍스트
                },
                lineStyle: {
                  type: "dotted", // 점선 스타일
                  color: "#ffc800",
                },
              },
              {
                yAxis: 5, // 표시하고 싶은 y값
                label: {
                  formatter: "", // 원하는 라벨 텍스트
                  // position: "center", // 라벨 위치를 선의 끝에 설정
                },
                lineStyle: {
                  type: "dotted", // 점선 스타일
                  color: "red",
                },
              },
            ],
          },
        },
      ],
    }),
    [chartData]
  );

  return (
    <S.LineSectionChartBox>
      <ReactECharts
        echarts={echarts}
        option={options}
        opts={{ renderer: "svg" }}
      />
    </S.LineSectionChartBox>
  );
};
